import { render, staticRenderFns } from "./changeOwner.vue?vue&type=template&id=1bb73f13&"
import script from "./changeOwner.vue?vue&type=script&lang=js&"
export * from "./changeOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb73f13')) {
      api.createRecord('1bb73f13', component.options)
    } else {
      api.reload('1bb73f13', component.options)
    }
    module.hot.accept("./changeOwner.vue?vue&type=template&id=1bb73f13&", function () {
      api.rerender('1bb73f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/txPairManage/changeOwner.vue"
export default component.exports